export const schemaItems = ($http: HttpApi) => ({
  get: ({ workflowStepId, schemaItemId, parameterPath = null }: { workflowStepId: string, schemaItemId: string, parameterPath?: string | null }) => $http.$get(
    `/workflow_steps/${workflowStepId}/schema_items/${schemaItemId}`,
    { params: { child_parameter_path: parameterPath } },
  ),
});
